"use client";

// src/components/atoms/Accordion/Accordion.tsx
import { useCallback, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Accordion = ({ question, answer, ref }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = useCallback(() => {
    setIsOpen((value) => !value);
  }, []);
  return /* @__PURE__ */ jsxs(
    "li",
    {
      ref,
      className: `flex overflow-hidden relative flex-col p-16 w-full lg:max-w-[785px] bg-display-0 rounded-[8px] lg:rounded-[16px] border-[2px] border-display-200 border-solid `,
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            onClick: handleClick,
            className: "flex justify-between items-center cursor-pointer",
            children: [
              /* @__PURE__ */ jsx("p", { className: "font-medium text-lg lg:text-xl", children: question }),
              /* @__PURE__ */ jsx(
                "button",
                {
                  className: `
        select-none
        relative ml-8 flex h-40 min-h-[40px] w-40 min-w-[40px] cursor-pointer
        items-center justify-center whitespace-normal rounded-[50%] bg-display-0 p-0 font-medium text-stone-500 no-underline outline-none
        before:absolute before:h-[21px] before:w-2 before:bg-stone-500 before:transition-all before:duration-[150ms]
        after:absolute after:h-2 after:w-[21px] after:bg-stone-500
        sm:w-[fit-content] 
        ${isOpen ? "before:rotate-90" : ""}`
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            dangerouslySetInnerHTML: { __html: answer },
            className: `grid overflow-hidden gap-8 max-h-0 font-normal transition-all duration-[150ms] text-base ${isOpen && "mt-16 max-h-full"}`
          }
        )
      ]
    }
  );
};
var Accordion_default = Accordion;

export {
  Accordion_default
};
